export interface ProductDossierListItem {
  id: string
  name: string
  recordName?: string
  readiness: number
  jurisdictions: string[]
  updated: string
}

export const productDossiers: ProductDossierListItem[] = [
  { id: 'card-complex-ven', name: 'Veno Complex Capsules', recordName: 'Veno Complex Capsules', readiness: 24, jurisdictions: ['IT'], updated: 'Today' },
  { id: 'adult-snacks-protein', name: 'Cheese Snack', recordName: 'Cheese Snack', readiness: 32, jurisdictions: ['PH'], updated: 'Today' },
  { id: 'orange-immunity-powder', name: 'Orange Immunity Powder', recordName: 'Orange Immunity Powder', readiness: 45, jurisdictions: ['AU', 'SG'], updated: '1d ago' },
  { id: 'chocolate-powdered-drink', name: 'Chocolate Powdered Drink (Hot or Cold)', readiness: 75, jurisdictions: ['AU'], updated: '21d ago' },
  { id: 'beauty-vitamin-gummies', name: 'Beauty Vitamin Gummies', readiness: 22, jurisdictions: ['AU'], updated: '22 Jun 2026' },
]
